import { useState } from "react";
import { useInbound } from "../hooks/useInbound";
import { Button } from "@tonic/shared/components/ui";
import { Input } from "@tonic/shared/components/ui";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@tonic/shared/components/ui";
import { DataTable } from "@/components/ui/data-table";
import { columns } from "./columns";
import { Search, Filter } from "lucide-react";

export function InboundListPage() {
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const { data: inboundItems, isLoading } = useInbound();

  const filteredItems = inboundItems?.filter((item) => {
    const matchesSearch =
      !searchQuery ||
      item.reference.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.items.some((i) => 
        i.sku.toLowerCase().includes(searchQuery.toLowerCase()) ||
        i.name.toLowerCase().includes(searchQuery.toLowerCase())
      );

    const matchesStatus =
      statusFilter === "all" || item.status === statusFilter;

    return matchesSearch && matchesStatus;
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">Inbound Items</h1>
        <Button>
          Record Inbound Item
        </Button>
      </div>

      <div className="flex items-center space-x-2">
        <div className="relative flex-1">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search by reference, SKU, or name..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-8"
          />
        </div>
        <Select
          value={statusFilter}
          onValueChange={setStatusFilter}
        >
          <SelectTrigger className="w-[180px]">
            <Filter className="mr-2 h-4 w-4" />
            <SelectValue placeholder="Filter by status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Status</SelectItem>
            <SelectItem value="pending">Pending</SelectItem>
            <SelectItem value="inspecting">Inspecting</SelectItem>
            <SelectItem value="assigned">Assigned</SelectItem>
            <SelectItem value="completed">Completed</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <DataTable
        columns={columns}
        data={filteredItems || []}
        isLoading={isLoading}
      />
    </div>
  );
}
